import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearSelectedAgency } from '../../../entities/agency/model/agencySlice'
import { selectAgencyState } from '../../../entities/agency/model/selectors'
import { getLanguageSection } from '../../../shared/services/languageService'

export default function AgencySelectedDetails() {
  const language = getLanguageSection('agentregister')
  const selectedAgencyLanguage = language?.selectedAgency || {}
  const dispatch = useDispatch()
  const { selectedAgency } = useSelector(selectAgencyState)

  if (!selectedAgency) {
    return (
      <div className="mx-auto mt-5 max-w-5xl rounded-2xl border border-dashed border-slate-300 bg-white p-5 text-center shadow-sm">
        <div className="text-sm font-black text-[#11183f]">{selectedAgencyLanguage.emptyTitle || 'Aun no has seleccionado una agencia'}</div>
        <p className="m-0 mt-2 text-sm leading-6 text-slate-500">{selectedAgencyLanguage.emptyText || 'Cuando elijas una, aqui veras sus datos antes de continuar con tu registro como agente.'}</p>
      </div>
    )
  }

  return (
    <div className="mx-auto mt-5 max-w-5xl rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <h3 className="m-0 min-w-0 text-sm font-black uppercase leading-6 text-[#11183f]">
          {selectedAgencyLanguage.titlePrefix || 'Agencia seleccionada:'} {String(selectedAgency.name || selectedAgencyLanguage.noName || 'Sin nombre').toUpperCase()}
        </h3>

        <button
          type="button"
          className="inline-flex h-9 items-center justify-center rounded-xl border border-slate-200 bg-white px-3 text-xs font-black text-slate-600 hover:bg-slate-50"
          onClick={() => dispatch(clearSelectedAgency())}
        >
          {selectedAgencyLanguage.clearButton || 'Limpiar'}
        </button>
      </div>

      <div className="grid gap-2 text-sm leading-6 text-slate-600">
        <div>
          <span className="font-black text-slate-700">{selectedAgencyLanguage.addressLabel || 'Dirección:'}</span>{' '}
          {selectedAgency.address || selectedAgencyLanguage.unavailable || 'No disponible'}
        </div>
        <div>
          <span className="font-black text-slate-700">{selectedAgencyLanguage.phoneLabel || 'Teléfono:'}</span>{' '}
          {selectedAgency.phone || selectedAgencyLanguage.unavailable || 'No disponible'}
        </div>
      </div>
    </div>
  )
}
